import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SelectivePreloadingStrategy implements PreloadingStrategy {
  // Define critical routes that should be preloaded
  private criticalRoutes = [
    'home',
    'feed',
    'login',
    'my-duckings',
    'world-map',
    'message-list'
  ];

  preload(route: Route, load: () => Observable<any>): Observable<any> {
    // Check if route has preload data set to true
    if (route.data && route.data['preload']) {
      console.log('Preloading module: ' + route.path);
      return load();
    }

    // Check if route path is in critical routes list
    if (route.path && this.criticalRoutes.includes(route.path)) {
      console.log('Preloading critical module: ' + route.path);
      return load();
    }

    // Don't preload non-critical routes
    return of(null);
  }
}